<template>
    <Header />
    <div v-if="isLoading">
        <StageList />
    </div>
    <a-row v-else type="flex" justify="space-around" align="middle" class="spin">
        <a-spin size="large" />
    </a-row>
</template>
<script>
import StageList from "@/components/stage/List.vue";
import orderMixin from "@/mixins/orderMixin";
import Header from "@/components/Header.vue";

export default {
    name: 'StagesView',
    components: { Header, StageList },
    mixins: [orderMixin],
}
</script>
<style scoped>
.spin {
    padding: 30px 50px;
}
</style>